module.exports = __webpack_public_path__ + "img/html-evolution-15.06039f6b.webp";